export default "__VITE_PUBLIC_ASSET__495665df__"